import { Box } from "@mui/material";
import FullLogo from '../../assets/svg/logo.svg';
import ShortLogo  from '../../assets/image/circle-logo.png'; 

const Logo = ({ collapsed, height, width, ...boxProps }) => {
  return (
<Box
  mb={2}
  sx={{
    height: collapsed ? 50 : 80, 
    display: 'flex',
    alignItems: 'center',
  }}
  {...boxProps}
>
  <img
    src={collapsed ? ShortLogo : FullLogo}
    alt="Logo"
    height={collapsed ? 60 : 50}
    width={collapsed ? 40 : 120}
  />
</Box>


  );
};

export default Logo;
